// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"341":"c7933188","3208":"c7933188","4314":"56cf8225","4659":"c7933188","5080":"1d00e02d","7938":"1d00e02d","9491":"c7933188","9668":"c7933188"}[chunkId] + ".chunk.css";
};